var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.844 37.3295L18.8476 37.3842H18.9024H22.695C23.9115 37.3842 24.5626 38.8159 23.7633 39.7328L20.4777 43.5012L15.0873 49.6844L13.6178 47.9988L6.4114 39.7327L6.36727 39.7712L6.4114 39.7327C5.61196 38.8157 6.2632 37.3841 7.47968 37.3841H10.6742H10.7353L10.7327 37.323C10.7162 36.9468 10.7067 36.5695 10.7067 36.1908C10.7067 29.4344 13.3377 23.0828 18.1151 18.3053C22.8926 13.5279 29.2442 10.8969 36.0006 10.8969C42.3527 10.8969 48.3464 13.2233 53.011 17.4717L47.7398 23.6384C44.6645 20.7604 40.535 18.9956 36.0006 18.9956C26.519 18.9956 18.8054 26.7092 18.8054 36.1909C18.8054 36.5736 18.8192 36.9531 18.844 37.3295Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.117083
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6346 34.9486L60.2597 28.7832L56.9146 24.9463L52.1387 30.4245L48.1946 34.9486C47.3623 35.9034 48.0403 37.3942 49.307 37.3942H53.0951C52.4754 46.2841 45.0459 53.3276 36.0013 53.3276C32.0532 53.3276 28.413 51.9848 25.5123 49.7328L20.1641 55.9896C24.6445 59.5877 30.1722 61.5433 36.0014 61.5433C42.7733 61.5433 49.1398 58.9063 53.9283 54.1178C58.432 49.6141 61.0319 43.7143 61.3252 37.3943H64.5223C65.7889 37.3942 66.4669 35.9034 65.6346 34.9486Z",
    fill: "#F30002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.b88b7b701d955597003d904f65da64d6.svg";
export { ForwardRef as ReactComponent };